
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';

@Component({ components: { Popup } })
export default class ConfirmCancellationPopup extends Vue {
  @Prop() title!: '会議室の設定' | '会議室設定' | 'ルームの編集';
  @Emit()
  close() {}
  @Emit()
  confirm() {}
  onConfirm(): void {
    this.confirm();
  }

  hidePopup(): void {
    this.close();
  }
}
